import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useLayoutEffect } from "../fable_modules/Feliz.2.9.0/ReactInterop.js";
import { createDisposable } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { createObj } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { join } from "../fable_modules/fable-library-js.4.29.0/String.js";
import { empty, singleton, append, delay, toList, iterate } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { some, toArray } from "../fable_modules/fable-library-js.4.29.0/Option.js";
import { ofArray } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { ofOption } from "./Prelude.js";

function Dialog(props) {
    let elems, children;
    const ref = reactApi.useRef(undefined);
    useLayoutEffect((_arg) => {
        let m;
        const matchValue = ref.current;
        let matchResult, m_1;
        if (matchValue != null) {
            if ((m = matchValue, !m.open)) {
                matchResult = 0;
                m_1 = matchValue;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                m_1.showModal();
                break;
            }
        }
        return createDisposable(() => {
        });
    });
    return createElement("dialog", createObj(ofArray([["ref", ref], ["aria-labelledby", join(" ", ["dialog-title"])], ["onClose", (_arg_1) => {
        props.Close(false);
    }], (elems = [createElement("h1", {
        id: "dialog-title",
        children: props.Title,
    }), props.Children(() => {
        iterate((m_2) => {
            m_2.close();
        }, toArray(ref.current));
    }), (children = toList(delay(() => append(props.Cancel ? singleton(createElement("button", {
        className: "cancel",
        onClick: (_arg_2) => {
            props.Close(false);
        },
        "aria-label": "Cancel",
    })) : empty(), delay(() => singleton(createElement("button", {
        className: "ok",
        onClick: (_arg_3) => {
            props.Close(true);
        },
        "aria-label": "Ok",
    })))))), createElement("div", {
        children: reactApi.Children.toArray(Array.from(children)),
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function EditDialogToggle(props) {
    const patternInput = reactApi.useState(undefined);
    const setState = patternInput[1];
    const xs = [props.Toggle(() => {
        setState(some(props.State));
    }), ofOption((state_1) => createElement(Dialog, {
        Cancel: true,
        Children: (close) => props.Children(close, state_1, (arg) => {
            setState(some(arg));
        }),
        Close: (ok) => {
            if (ok) {
                props.Dispatch(state_1);
            }
            setState(undefined);
        },
        Title: props.Title,
    }), patternInput[0])];
    return react.createElement(react.Fragment, {}, ...xs);
}

function toggleButton(css, label, toggle) {
    return createElement("button", createObj(ofArray([["className", css], ["aria-haspopup", "dialog"], ["onClick", (arg) => {
        toggle(void arg);
    }], label])));
}

export function toggleEditWith(buttonText, title, state, dispatch, children) {
    return createElement(EditDialogToggle, {
        Children: children,
        Dispatch: dispatch,
        State: state,
        Title: title,
        Toggle: (toggle) => toggleButton("button", ["children", buttonText], toggle),
    });
}

export function toggleEdit(title, state, dispatch, children) {
    return createElement(EditDialogToggle, {
        Children: children,
        Dispatch: dispatch,
        State: state,
        Title: title,
        Toggle: (toggle) => toggleButton("edit", ["aria-label", "Edit"], toggle),
    });
}

export function confirmAction(buttonText, title, dispatch, children) {
    return toggleEditWith(buttonText, title, undefined, dispatch, (_arg, unitVar, _arg_1) => children);
}

//# sourceMappingURL=Dialog.js.map
